import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b5498e30")

_pushScopeId("data-v-b5498e30")
const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = { style: {"float":"right"} }
const _hoisted_3 = { class: "height50px padding-0-15" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ['card-main',_ctx.type]
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return (_openBlock(), _createBlock("div", { key: index }, [
          _createVNode("label", null, _toDisplayString(item[_ctx.label1Alias] ? item[_ctx.label1Alias] : '--'), 1),
          _createVNode("label", _hoisted_2, _toDisplayString(item[_ctx.label2Alias]), 1)
        ]))
      }), 128))
    ], 2),
    _createVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
})